import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../grid/grid';
import '../typography/typography';
import css from './button.css';

const Button = ({
  children,
  type,
  className,
  secondary,
  icon,
  inverse,
  disabled,
  ...otherProps
}) => (
  <button
    className={classnames(
      css['ds-button'],
      {
        [css['ds-button--secondary']]: secondary,
        [css['ds-button--inverse']]: inverse,
        [css['ds-button--icon']]: icon,
      },
      className,
    )}
    // eslint-disable-next-line react/button-has-type
    type={type}
    disabled={disabled}
    {...otherProps}
  >
    {children}
  </button>
);

Button.defaultProps = {
  type: 'button',
  className: '',
  secondary: false,
  icon: false,
  inverse: false,
  disabled: false,
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  className: PropTypes.string,
  secondary: PropTypes.bool,
  icon: PropTypes.bool,
  inverse: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Button;
